import '@inkline/inkline/src/inkline.scss';

import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import router from './routes';
import store from './store'
import i18n from './i18n'
import { Inkline } from '@inkline/inkline/src';

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(Inkline);

new Vue({
  router,
  store: new Vuex.Store(store),
  i18n,
  render: h => h(App)
}).$mount('#app')
